import type { PoliciesResponse } from '@/data/timeOffAccrual/types/common';
import type { DataResponse, QueryString } from '@/data/types';
import Scheduling from '@/shared/api/scheduling';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

interface FetchPoliciesForUserArgs {
  userId: string;
  params?: QueryString;
}

export const fetchPoliciesForUser = createWiwAsyncThunk<DataResponse<PoliciesResponse>, FetchPoliciesForUserArgs>(
  'timeOff/policies/fetchPoliciesForUser',
  async ({ userId, params = {} }, { rejectWithValue }) => {
    try {
      return await Scheduling.query(params).get(`/timeoff/policies/user/${userId}`);
    } catch (error) {
      return rejectWithValue(parseAPIError(error));
    }
  },
);
